/**
 * BaseValidator class.
 * All validators should inherit from this class.
 *
 * @copyright Realeyes OU. All rights reserved.
 */


import EventEmitter from 'events';


/**
 * @abstract
 * @class
 */
export default class BaseValidator extends EventEmitter {
    /**
     * @abstract
     */
    constructor() {
        super();
        if (this.constructor === BaseValidator) throw new Error('Cannot instantiate abstract class BaseValidator');
    }

    /**
     * @abstract
     * @return {Promise}
     */
    start() {
        throw new Error('not implemented');
    }

    /**
     * @abstract
     * @return {Promise}
     */
    stop() {
        throw new Error('not implemented');
    }
}
